<!-- signup.component.html -->
<div class="signup-card" style="z-index: 1;">
  <div class="header d-flex justify-content-between">
    <i class="fa fa-times cursor-pointer" aria-hidden="true" (click)="dissmissModal()"></i>
  </div>
  <div class="signup-container">
    <div class="signup-card">
      <h2>Forgot Password</h2>
      <p class="subtitle">Please enter your username to reset the password</p>

      <form [formGroup]="forgotpassForm" (ngSubmit)="onSubmit()" class="signup-form">
        <div class="form-field">
          <label for="username">Username</label>
          <input
            id="username"
            type="text"
            autocomplete="off"
            formControlName="username"
            class="form-control"
            maxlength="20"
            [class.is-invalid]="forgotpassForm.get('username')?.invalid && forgotpassForm.get('username')?.touched"
            placeholder="Enter username">
          <div class="error-message" *ngIf="forgotpassForm.get('username')?.invalid && forgotpassForm.get('username')?.touched">
            {{ getErrorMessage('username') }}
          </div>
        </div>

        <div class="captcha-container">
          <div
            class="captcha-background"
            [style.backgroundImage]="'url(' + noiseImage + ')'">
            <div
              *ngFor="let captcha of captchaText"
              [ngStyle]="captcha.style"
              class="captcha-character">
              {{ captcha.char }}
            </div>
            <button class="refresh-button" (click)="refreshCaptcha()">
              <i class="fa fa-refresh"></i>
            </button>
          </div>

          <div class="captcha-input">
            <input
              type="text"
              placeholder="Enter Captcha"
              formControlName="captcha"
              (input)="validateCaptcha($event)"
              maxlength="8"
              (paste)="onPaste($event)"
              class="captcha-text-input" />
            <div class="captcha-status">
              <span *ngIf="forgotpassForm.get('captcha')?.value && validCaptcha" class="valid-status">
                ✅
              </span>
              <span *ngIf="forgotpassForm.get('captcha')?.value && !validCaptcha" class="invalid-status">
                ❌
              </span>
            </div>
          </div>
        </div>

        <button type="submit" class="btn-submit" [disabled]="forgotpassForm.invalid || !validCaptcha">
          Submit
        </button>
      </form>
    </div>
  </div>
</div>
